/* layout lines */
import { pageTrackingDescriptor } from './tracking/pageTracking.descriptor';

/* common lines */
import { allInclusivePushDescriptor } from './all-inclusive-push/allInclusivePush.descriptor';
import { checklistDescriptor } from './checklist/checklist.descriptor';
import { crisisAlertDescriptor } from './crisis-alert/crisisAlert.descriptor';
import { destinationsDescriptor } from './destinations/destinations.descriptor';
import { downloadLinksListDescriptor } from './download-links-list/downloadLinksList.descriptor';
import { editorialFoldingBlockDescriptor } from './editorial-folding-block/editorialFoldingBlock.descriptor';
import { eventFormDescriptor } from './event-form/eventForm.descriptor';
import { buttonTicketDescriptor } from './button-ticket/buttonTicket.descriptor';
import { immersiveDescriptor } from './immersive/immersive.descriptor';
import { instagramDescriptor } from './instagram/instagram.descriptor';
import { lastSeenProductsDescriptor } from './last-seen-products/lastSeenProducts.descriptor';
import { mediaTextHorizontalDescriptor } from './media-text-horizontal/mediaTextHorizontal.descriptor';
import { mediaTextVerticalDescriptor } from './media-text-vertical/mediaTextVertical.descriptor';
import { mediaThumbnailDescriptor } from './media-thumbnail/mediaThumbnail.descriptor';
import { navigationTabDescriptor } from './navigation-tab/navigationTab.descriptor';
import { navigationTabsDescriptor } from './navigation-tabs/navigationTabs.descriptor';
import { offersGridDescriptor } from './offers-grid/offersGrid.descriptor';
import { offersPushDescriptor } from './offers-push/offersPush.descriptor';
import { prebookingFormDescriptor } from './prebooking-form/prebookingForm.descriptor';
import { productTagsDescriptor } from './product-tags/productTags.descriptor';
import { productsFiltersDescriptor } from './products-filters/productsFilters.descriptor';
import { productsGridDescriptor } from './products-grid/productsGrid.descriptor';
import { sectionDescriptor } from './section/section.descriptor';
import { sectionsDescriptor } from './sections/sections.descriptor';
import { smartFaqDescriptor } from './smart-faq/smartFaq.descriptor';
import { submissionStatusDescriptor } from './submission-status/submissionStatus.descriptor';
import { tabDescriptor } from './tab/tab.descriptor';
import { tabsDescriptor } from './tabs/tabs.descriptor';
import { teaserCardsDescriptor } from './teaser-cards/teaserCards.descriptor';
import { testABDescriptor } from './test-ab/testAB.descriptor';
import { textDescriptor } from './text/text.descriptor';
import { thematicDescriptor } from './thematic/thematic.descriptor';
import { titleAndTextDescriptor } from './title-and-text/titleAndText.descriptor';
import { tripadvisorTestimonyDescriptor } from './tripadvisor-testimony/tripadvisorTestimony.descriptor';
import { videoDescriptor } from './video/video.descriptor';

/* home lines : homepage recommended */
import { highlightDescriptor } from './highlight/highlight.descriptor';
import { brandPromiseDescriptor } from './brand-promise/brandPromise.descriptor';

/* country lines : webedia countryId needed */
import { countryEventsDescriptor } from './country-events/countryEvents.descriptor';
import { countryInfosDescriptor } from './country-infos/countryInfos.descriptor';
import { countryIntroductionDescriptor } from './country-introduction/countryIntroduction.descriptor';
import { countryPoiDescriptor } from './country-poi/countryPoi.descriptor';

/* offer lines : offerId needed */
import { offerDescriptionDescriptor } from './offer-description/offerDescription.descriptor';
import { offerLegalInformationDescriptor } from './offer-legal-information/offerLegalInformation.descriptor';
import { offerSEODescriptor } from './offer-seo/offerSeo.descriptor';

/* cruise lines : resortId/productId needed (only cruise ID) */
import { cruiseBookingDescriptor } from './cruise-booking/cruiseBooking.descriptor';
import { cruiseProgramDescriptor } from './cruise-program/cruiseProgram.descriptor'; // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */
import { productAccessAndMapDescriptor } from './product-access-and-map/productAccessAndMap.descriptor';
import {
  productAccommodationsDescriptor,
  productAccommodationsExclusiveCollectionDescriptor,
} from './product-accommodations/productAccommodations.descriptor';
import { productActivitiesDescriptor } from './product-activities/productActivities.descriptor';
import { productBarsDescriptor } from './product-bars/productBars.descriptor';
import { productBookingBEDescriptor } from './product-booking/productBookingBE.descriptor';
import { productBreadcrumbDescriptor } from './product-breadcrumb/productBreadcrumb.descriptor';
import { productChildcaresDescriptor } from './product-childcares/productChildcares.descriptor';
import { productCommunityQuestionsDescriptor } from './product-community-questions/productCommunityQuestions.descriptor';
import { productDestinationDescriptor } from './product-destination/productDestination.descriptor';
import { productExclusiveCollectionSpaceDescriptor } from './product-exclusive-collection-space/productExclusiveCollectionSpace.descriptor';
import { productFlashInfoDescriptor } from './product-flash-info/productFlashInfo.descriptor';
import { productGoogleStreetViewDescriptor } from './product-google-street-view/productGoogleStreetView.descriptor';
import { productImageMapDescriptor } from './product-image-map/productImageMap.descriptor';
import { productImmersiveDescriptor } from './product-immersive/productImmersive.descriptor';
import { productInformationSummaryDescriptor } from './product-information-summary/productInformationSummary.descriptor';
import { productInstagramDescriptor } from './product-instagram/productInstagram.descriptor';
import { productIntroductionDescriptor } from './product-introduction/productIntroduction.descriptor';
import { productMeetingRoomInfoDescriptor } from './product-meeting-room-info/productMeetingRoomInfo.descriptor';
import { productMultimediaDescriptor } from './product-multimedia/productMultimedia.descriptor';
import { productMustTryExperiencesDescriptor } from './product-must-try-experiences/productMustTryExperiences.descriptor';
import { productPriceRemoteDescriptor } from './product-price-remote/productPriceRemote.descriptor';
import { productPriceTicketDescriptor } from './product-price-ticket/productPriceTicket.descriptor';
import { productPriceTicketCustomDescriptor } from './product-price-ticket-custom/productPriceTicketCustom.descriptor';
import { productQuotationFormDescriptor } from './product-quotation-form/productQuotationForm.descriptor';
import { productRecommendationsDescriptor } from './product-recommendations/productRecommendations.descriptor';
import { productRelatedProductsDescriptor } from './product-related-products/productRelatedProducts.descriptor';
import { productRestaurantsDescriptor } from './product-restaurants/productRestaurants.descriptor';
import { productSEOTitleDescriptor } from './product-seo-title/productSEOTitle.descriptor';
import { productServicesDescriptor } from './product-services/productServices.descriptor'; // no ID but commonly on product page
import { productSignaturesDescriptor } from './product-signatures/productSignatures.descriptor'; // no ID but commonly on product page
import { productSpaceIntroductionDescriptor } from './product-space-introduction/productSpaceIntroduction.descriptor'; // no ID but commonly on product page
import { productStrengthsDescriptor } from './product-strengths/productStrengths.descriptor';
import { productSummaryDescriptor } from './product-summary/productSummary.descriptor';
import { productTripadvisorDescriptor } from './product-tripadvisor/productTripadvisor.descriptor';
import { productWellnessDescriptor } from './product-wellness/productWellness.descriptor';
import { productWellnessLegacyDescriptor } from './product-wellness-legacy/productWellnessLegacy.descriptor';

/* tour lines : resortId/productId needed (only tour ID) */
import { tourIntroductionDescriptor } from './tour-introduction/tourIntroduction.descriptor';
import { tourPracticalInformationDescriptor } from './tour-practical-information/tourPracticalInformation.descriptor';
import { tourProgramDescriptor } from './tour-program/tourProgram.descriptor';

const descriptors = [
  allInclusivePushDescriptor,
  brandPromiseDescriptor,
  checklistDescriptor,
  countryEventsDescriptor,
  countryInfosDescriptor,
  countryIntroductionDescriptor,
  countryPoiDescriptor,
  crisisAlertDescriptor,
  cruiseBookingDescriptor,
  cruiseProgramDescriptor,
  destinationsDescriptor,
  downloadLinksListDescriptor,
  editorialFoldingBlockDescriptor,
  eventFormDescriptor,
  buttonTicketDescriptor,
  highlightDescriptor,
  immersiveDescriptor,
  instagramDescriptor,
  lastSeenProductsDescriptor,
  mediaTextHorizontalDescriptor,
  mediaTextVerticalDescriptor,
  mediaThumbnailDescriptor,
  navigationTabDescriptor,
  navigationTabsDescriptor,
  offerDescriptionDescriptor,
  offerLegalInformationDescriptor,
  offerSEODescriptor,
  offersGridDescriptor,
  offersPushDescriptor,
  pageTrackingDescriptor,
  prebookingFormDescriptor,
  productAccessAndMapDescriptor,
  productAccommodationsDescriptor,
  productAccommodationsExclusiveCollectionDescriptor,
  productActivitiesDescriptor,
  productBarsDescriptor,
  productBookingBEDescriptor,
  productBreadcrumbDescriptor,
  productChildcaresDescriptor,
  productCommunityQuestionsDescriptor,
  productDestinationDescriptor,
  productExclusiveCollectionSpaceDescriptor,
  productFlashInfoDescriptor,
  productGoogleStreetViewDescriptor,
  productImageMapDescriptor,
  productImmersiveDescriptor,
  productInformationSummaryDescriptor,
  productInstagramDescriptor,
  productIntroductionDescriptor,
  productMeetingRoomInfoDescriptor,
  productMultimediaDescriptor,
  productMustTryExperiencesDescriptor,
  productPriceRemoteDescriptor,
  productPriceTicketDescriptor,
  productPriceTicketCustomDescriptor,
  productRecommendationsDescriptor,
  productRelatedProductsDescriptor,
  productRestaurantsDescriptor,
  productSEOTitleDescriptor,
  productServicesDescriptor,
  productsFiltersDescriptor,
  productsGridDescriptor,
  productQuotationFormDescriptor,
  productSignaturesDescriptor,
  productSpaceIntroductionDescriptor,
  productStrengthsDescriptor,
  productSummaryDescriptor,
  productTagsDescriptor,
  productTripadvisorDescriptor,
  productWellnessDescriptor,
  productWellnessLegacyDescriptor,
  sectionDescriptor,
  sectionsDescriptor,
  smartFaqDescriptor,
  submissionStatusDescriptor,
  tabDescriptor,
  tabsDescriptor,
  teaserCardsDescriptor,
  testABDescriptor,
  textDescriptor,
  thematicDescriptor,
  titleAndTextDescriptor,
  tourIntroductionDescriptor,
  tourPracticalInformationDescriptor,
  tourProgramDescriptor,
  tripadvisorTestimonyDescriptor,
  videoDescriptor,
];

export const descriptorsLibrary = descriptors.reduce((acc, descriptor) => {
  if (acc[descriptor.name]) {
    throw new Error(`A descriptor named ${descriptor.name} is already set.`);
  }

  acc[descriptor.name] = descriptor;

  return acc;
}, {});

export type DescriptorsLibrary = { [$Keys<typeof descriptorsLibrary>]: Descriptor };
